import React, { useEffect, useState } from 'react';
import { ButtonBlockContainer, WrapperTitle } from './styled.MyAuditSummary';
import { useTranslation } from 'react-i18next';
import { SummaryCard } from '../../../myAudit/components/SummaryCard';
import { Headline2 } from '../../../../app/common/typography';
import { ISummaryCard, ISummaryList } from '../../../../app/@types/summaryCard';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getMyAuditSummary } from '../../../../requests/myAudit';
import { SummarySkeleton } from './../../MyAuditSkeleton/SummarySkeleton';
import { DateFormatEnum, formatDate } from '../../../../helpers/dates';
import { ButtonLarge } from '../../../common/sharedComponents/buttons/ButtonLarge';
import { sentryReport } from '../../../../helpers/sentry';
import { showErrorMessage } from '../../../../helpers/showMessage';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';
import {
  HeaderContainer,
  StyledMyAuditContainer,
} from '../../../common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { AppHeader } from '../../../common/sharedComponents/AppHeader';

export function MyAuditSummary () {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const auditId = Number(searchParams.get('auditId'));

  const [myAuditSummaryList, setMyAuditSummaryList] = useState<ISummaryList>();

  useEffect(() => {
    if (auditId) {
      fetchMyAuditSummary();
    }
  }, [auditId]);

  const fetchMyAuditSummary = () => {
    getMyAuditSummary(auditId)
      .then((response) => {
        if (response && response.data) {
          setMyAuditSummaryList(response.data);
        }
      })
      .catch((error) => {
        showErrorMessage(
          t('COMMON.ALERT_MESSAGES.ERROR_FETCHING_MYAUDIT_SUMMARY')
        );
        sentryReport(error.response.data, error.message, error.code, {
          summaryError: t(
            'COMMON.ALERT_MESSAGES.ERROR_FETCHING_MYAUDIT_SUMMARY'
          ),
          path: '/myaudit/summary/${auditId}',
        });
      });
  };

  return (
    <>
      <HeaderContainer>
        <AppHeader title={t('COMMON.MY_AUDIT.TITLE')} />
      </HeaderContainer>
      <StyledMyAuditContainer>
        <WrapperTitle>
          <Headline2>
            {myAuditSummaryList &&
              myAuditSummaryList.creationDate &&
              `${t('COMMON.MY_AUDIT.TITLES.CREATED')} ${
                formatDate(
                  myAuditSummaryList.creationDate,
                  DateFormatEnum.ddmmyy
                ) || ''
              }`}
          </Headline2>
        </WrapperTitle>
        {myAuditSummaryList &&
          myAuditSummaryList.auditors.length > 0 &&
        <>
          {myAuditSummaryList.auditors.map((summary: ISummaryCard) => (
              <SummaryCard
                  key={summary.auditorId}
                  statusItems={summary.statusItems}
                  percentage={summary.percentage}
                  department={summary.department}
                  sections={summary.sections}
                  auditor={summary.auditor}
                  dueDate={myAuditSummaryList.dueDate}
              />
          ))}
        <ButtonBlockContainer>
          <ButtonBlockColumn>
            <ButtonLarge
              outlined={true}
              inverted={true}
              title={t('COMMON.MY_AUDIT.BUTTON.BACK')}
              backgroundColor={'oxfordBlue'}
              onClick={() => {
                navigate(-1);
              }}
            />
          </ButtonBlockColumn>
        </ButtonBlockContainer>
        </>
        }
        {!myAuditSummaryList && (
          <>
            <SummarySkeleton />
          </>
        )}
      </StyledMyAuditContainer>
    </>
  );
}
